import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
var _dec, _class;
import { injectable } from 'inversify';
import 'reflect-metadata';
/**
 * 更新图层样式，初始图层相关配置
 */
var LayerStylePlugin = (_dec = injectable(), _dec(_class = /*#__PURE__*/function () {
  function LayerStylePlugin() {
    _classCallCheck(this, LayerStylePlugin);
  }
  _createClass(LayerStylePlugin, [{
    key: "apply",
    value: function apply(layer) {
      layer.hooks.afterInit.tap('LayerMaskPlugin', function () {
        var _layer$getLayerConfig = layer.getLayerConfig(),
          maskLayers = _layer$getLayerConfig.maskLayers,
          enableMask = _layer$getLayerConfig.enableMask;
        // mask 初始化
        if (!layer.tileLayer && maskLayers && maskLayers.length > 0) {
          var _layer$masks;
          (_layer$masks = layer.masks).push.apply(_layer$masks, _toConsumableArray(maskLayers));
          layer.updateLayerConfig({
            mask: true && enableMask
          });
        }
      });
    }
  }]);
  return LayerStylePlugin;
}()) || _class);
export { LayerStylePlugin as default };